import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Testimonials from '../home/testimonials.js';
import { ReactComponent as IconDropdown } from '../../media/icons/dropdown.svg';


export default class BenefitsPlanners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp",
            question_expanded: false,
            questions_content: [
                {
                    "question": "Why should I use Guidr instead of planning my own trip from scratch?",
                    "answer": "Planning a trip can be overwhelming, with endless blogs, forums, and reviews to sift through. Our itineraries are created by locals and travel experts who know the best spots, hidden gems, and time-saving hacks—saving you hours of research while ensuring a well-structured, experience-rich trip."
                },
                {
                    "question": "How is Guidr different from working with a traditional travel agent?",
                    "answer": "Traditional travel agents typically charge high fees for custom itineraries, and they often prioritize commission-based bookings. Our platform offers curated, expert-backed itineraries at a fraction of the cost or no cost at all, giving you flexible, unbiased recommendations without any pressure to book specific services."
                },
                {
                    "question": "What types of travelers benefit most from using Guidr?",
                    "answer": "Whether you’re a solo traveler, couple, family, or group of friends, we offer itineraries for all types of travelers—budget-friendly trips, luxury experiences, adventure-packed journeys, and even niche interests like food tours or photography trips."
                },
                {
                    "question": "Why should I trust itineraries from Guidr?",
                    "answer": "Every itinerary is created by experienced travelers, locals, or industry experts who have explored the destinations firsthand. User ratings and reviews also help ensure quality and reliability. You can also look out for itineraries that are hand-picked and thoroughly reviewed by our staff."
                },
                {
                    "question": "How do I find the right itinerary for my trip?",
                    "answer": "You can search for itineraries based on destination, season, budget, or travel style. Filters help you refine your search to find the perfect plan."
                },
                {
                    "question": "Are all itineraries free, or do I need to pay?",
                    "answer": "At the moment, all itineraries are free."
                },
                {
                    "question": "What do I get when I unlock an itinerary?",
                    "answer": "You get a detailed day-by-day plan, travel tips, maps, recommendations, and sometimes exclusive deals on accommodations, tours, or activities."
                },
                {
                    "question": "Can I contact the itinerary creator for questions?",
                    "answer": "Some experts offer direct messaging or Q&A support through their social media accounts, like Instagram. Check the user profile details to see if this option is available."
                },
                {
                    "question": "How often are itineraries updated?",
                    "answer": "Experts regularly update their itineraries, especially for seasonal travel plans."
                },
                {
                    "question": "Do you offer custom itinerary planning services?",
                    "answer": "Some travel experts offer personalized itinerary services for an additional fee. Look for creators who provide custom planning options."
                },
                {
                    "question": "How can I access itineraries?",
                    "answer": "You first need to sign up and log in. Then you can browse itineraries by destination, season, or travel style. Once you find an itinerary you like, click on it to unlock the details."
                }
            ]
        };

        this.toggleQuestion = this.toggleQuestion.bind(this);
    }


    toggleQuestion(question) {
        if (question === this.state.question_expanded) {
            this.setState({
                question_expanded: false
            });
        } else {
            this.setState({
                question_expanded: question
            });
        }
    }


    render() {

        return (
            <div className="content-container">

                <Helmet>
                    {/* Add the breadcrumb schema as JSON-LD */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Guidr for travelers",
                                    "item": "https://guidr.net/travelers"
                                }
                                ]
                            }
                        `}
                    </script>
                    <title>{"Discover top-rated travel itineraries from locals and travel experts | Guidr"}</title>
                </Helmet>

                <div className="content-container hero-container">
                    <div className="hero__background">
                        <img src={this.state.background_url} alt={""} className={"hero__background-inner"} />
                    </div>
                    <div className="hero__background hero__background--overlay"></div>
                    <div className="content-wrapper--wide persona__hero-wrapper">
                        <div className=""></div>
                        <div className="persona__hero__title-container">
                            <h1 className="persona__hero__title__element text-title text-color-light">
                                Elevate your next trip with expert-curated itineraries
                            </h1>
                            <div className="persona__hero__title__element text-color-light">
                                Plan the trip of your dreams to any country or city in the world based on your travel preferences
                            </div>
                            <Link
                                to={"/trips?sort=rated"}
                                className="persona__hero__title__button button button-large button-primary-light"
                            >
                                Explore trending trips
                            </Link>
                        </div>
                    </div>
                </div>


                <div className="content-wrapper">
                    <div className="persona__explainer-container">

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">1</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Explore trips
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/travelers_1.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🗺️ Browse itineraries</span> by destination, season, interests, or budget and use filters to refine your search.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🌍 Explore trending destinations</span> and travel experts.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">👥 See what other itineraries</span> your favorite travel experts have to offer.
                                </p>
                            </div>
                        </div>

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">2</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Choose itineraries
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/travelers_2.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    {/* <span className="text-bold">🆓 Access free itineraries</span> instantly or purchase exclusive, expert-crafted itineraries for detailed insights. */}
                                    <span className="text-bold">🆓 Access free itineraries</span> instantly with expert-crafted, detailed insights.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🔗 Connect with travel experts</span> on different platforms to see if they match your vibe.
                                </p>
                            </div>
                        </div>

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">3</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Get instant access
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/travelers_3.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🗂️ View your ready-to-go itinerary</span> online with maps, tips, and recommendations.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">💬 Connect with travel experts</span> to clarify your questions or fine-tune your itinerary.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🛤️ Follow step-by-step guidance</span> for a seamless travel experience.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="content-wrapper">
                    <Testimonials
                        data={this.props.testimonials}
                    />
                </div>

                <div className="content-wrapper">
                    <div className="persona__faq-container">
                        <h2 className="persona__faq__title text-title">
                            Frequently asked questions (FAQ)
                        </h2>

                        <div className="persona__faq-wrapper">

                            {this.state.questions_content.map((element, i) => (
                                <div key={i} className={"persona__faq__element" + (this.state.question_expanded === i ? " persona__faq__element--expanded" : "")}>
                                    <div onClick={() => this.toggleQuestion(i)} className="persona__faq__element__question-wrapper">
                                        <div className="persona__faq__element__question__question">
                                            {element.question}
                                        </div>
                                        <div className={"persona__faq__element__question__icon"}>
                                            <IconDropdown className="persona__faq__element__question__icon-inner" />
                                        </div>
                                    </div>
                                    <div className={"persona__faq__element__answer"}>
                                        {element.answer}
                                    </div>
                                </div>
                            ))}

                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
